<template>
  <article class="home">
    <Top/>
    <Explaination/>
    <Place/>
    <Operation/>
  </article>
</template>

<script>
import { mapGetters } from 'vuex'
import setting from '@/setting.js'
import Top from '@/components/templates/Top'
import Explaination from '@/components/templates/Explaination'
import Place from '@/components/templates/Place'
import Operation from '@/components/templates/Operation'

export default {
  name: 'Home',
  components: {
    setting,
    mapGetters,
    Top,
    Explaination,
    Place,
    Operation
  },
  computed: {
    ...mapGetters(['museumList', 'mediaType'])
  },
  data () {
    return {
      setting
    }
  },
  methods: {
  },
  mounted () {
  },
  created () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  activated () {
  }
}
</script>
<style lang="postcss" scoped>
  @import '../assets/css/mixins.css';
  @import '../assets/css/variables.css';

  .home {
    margin: auto;
    overflow: hidden;
    padding-top: 80px;
  }
  @media (--breakPoint) {
  .home {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue